import { ArticleItem } from '../../types';

export const tenInnovativeMedicalDevicesEn: ArticleItem = {
  slug: "ten-innovative-medical-devices",
  title: "Ten Medical Devices Enter Innovation Channel: Breakthroughs Across Multiple Technology Tracks",
  summary: "Ten products are proposed to enter China's innovative medical device channel, covering AI-assisted diagnosis, surgical robotics, 3D-printed implants, and deep brain electrodes.",
  seo: {
    title: "Ten Medical Devices Enter Innovation Channel | HL Medical",
    description: "Ten medical devices are proposed to enter China's innovation channel, covering AI diagnosis, surgical robotics, 3D-printed implants, endoscopic systems, and deep brain electrodes.",
    keywords: "innovative medical device, China medical device innovation channel, AI medical device, surgical robot, 3D printed implant",
    canonicalUrl: "https://hlmedicalconsult.cn/en/articles/ten-innovative-medical-devices",
    alternateUrls: {
      en: "https://hlmedicalconsult.cn/en/articles/ten-innovative-medical-devices",
      cn: "https://hlmedicalconsult.cn/cn/articles/ten-innovative-medical-devices",
      xDefault: "https://hlmedicalconsult.cn/en/articles/ten-innovative-medical-devices"
    },
    ogTitle: "Ten Medical Devices Enter Innovation Channel",
    ogDescription: "The proposed products reflect concentrated breakthroughs across AI diagnosis, surgical robotics, 3D printing, and brain-computer interface related technologies.",
    ogType: "article"
  },
  date: "2026-05-08",
  category: "Innovation",
  readTime: "4 min read",
  sourceName: "HIGH-USABILITY",
  originalUrl: "https://www.highusability.com",
  sourceNote: "source: High Usability: www.high-usability.com",
  content: [
    { type: "section", text: "01" },
    { type: "heading", text: "Products Proposed for the Innovation Channel" },
    { type: "paragraph", text: "The products proposed to enter the innovation channel include:" },
    { type: "bullet", text: "Urethral bulking agent; applicant: Chengdu Chipu Biotechnology Co., Ltd." },
    { type: "bullet", text: "Additive manufactured PEEK patient-matched sternum and rib prosthesis; applicant: Dimension (Xi'an) Biomedical Technology Co., Ltd." },
    { type: "bullet", text: "Drug-eluting peripheral arterial stent system; applicant: Shanghai Hongmai Medical Technology Co., Ltd." },
    { type: "bullet", text: "Shoulder arthroplasty surgical navigation and positioning system; applicant: Beijing Estun Medical Technology Co., Ltd." },
    { type: "bullet", text: "Non-small cell lung cancer drug sensitivity test kit (in vitro cell culture method); applicant: Beijing Genecast Medical Laboratory Co., Ltd." },
    { type: "bullet", text: "Upper gastrointestinal electronic endoscopic surgery control system; applicant: Shanghai Aohua Endoscopy Co., Ltd." },
    { type: "bullet", text: "3D-printed tissue engineering scaffold for breast reconstruction; applicant: Shenzhen Breje Biotechnology Co., Ltd." },
    { type: "bullet", text: "Microsurgical operation control system; applicant: Ontai Microfine Medical Technology (Shanghai) Co., Ltd." },
    { type: "bullet", text: "Chest CT image-assisted diagnosis software; applicant: Shanghai United Imaging Intelligence Co., Ltd." },
    { type: "bullet", text: "Intracranial deep electrode; applicant: Beijing Zhiren Medical Technology Co., Ltd." },
    { type: "section", text: "02" },
    { type: "heading", text: "Multi-track Technology Breakthroughs" },
    { type: "paragraph", text: "This batch includes products across artificial intelligence-assisted diagnosis, surgical robotics, 3D-printed implants, and brain-computer interface related technologies." },
    { type: "paragraph", text: "The selection reflects that China's medical device innovation is moving from isolated breakthroughs toward integrated development across multiple technology platforms." },
    { type: "paragraph", text: "The inclusion of chest CT image-assisted diagnosis software has also renewed industry attention on the development of medical AI." }
  ]
};

export const tenInnovativeMedicalDevicesCn: ArticleItem = {
  slug: "ten-innovative-medical-devices",
  title: "10款医疗器械进入创新通道：多赛道技术集中突破",
  summary: "本批拟进入创新通道的产品覆盖人工智能辅助诊断、手术机器人、3D打印植入物及脑机接口等多个方向。",
  seo: {
    title: "10款医疗器械进入创新通道：多赛道技术集中突破 | 赫莱医药",
    description: "10款医疗器械拟进入创新通道，覆盖人工智能辅助诊断、手术机器人、3D打印植入物、内窥镜系统和颅内深部电极等方向。",
    keywords: "创新医疗器械, 医疗器械创新通道, 医疗AI, 手术机器人, 3D打印植入物",
    canonicalUrl: "https://hlmedicalconsult.cn/cn/articles/ten-innovative-medical-devices",
    alternateUrls: {
      en: "https://hlmedicalconsult.cn/en/articles/ten-innovative-medical-devices",
      cn: "https://hlmedicalconsult.cn/cn/articles/ten-innovative-medical-devices",
      xDefault: "https://hlmedicalconsult.cn/en/articles/ten-innovative-medical-devices"
    },
    ogTitle: "10款医疗器械进入创新通道",
    ogDescription: "本批项目显示，医疗器械创新正从单点突破走向多技术融合发展。",
    ogType: "article"
  },
  date: "2026-05-08",
  category: "创新器械",
  readTime: "约4分钟",
  sourceName: "HIGH-USABILITY",
  originalUrl: "https://www.highusability.com",
  sourceNote: "source: High Usability: www.high-usability.com",
  content: [
    { type: "section", text: "01" },
    { type: "heading", text: "拟进入创新通道产品" },
    { type: "paragraph", text: "本次拟进入创新通道的产品具体包括：" },
    { type: "bullet", text: "产品名称：尿道填充剂；申请人：成都奇璞生物科技有限公司" },
    { type: "bullet", text: "产品名称：增材制造聚醚醚酮患者匹配式胸肋骨假体；申请人：维度（西安）生物医疗科技有限公司" },
    { type: "bullet", text: "产品名称：药物洗脱外周动脉支架系统；申请人：上海鸿脉医疗科技有限公司" },
    { type: "bullet", text: "产品名称：肩关节置换手术导航定位系统；申请人：北京埃斯顿医疗科技有限公司" },
    { type: "bullet", text: "产品名称：非小细胞肺癌药物敏感性检测试剂盒（体外细胞培养法）；申请人：北京基石医学检验实验室有限公司" },
    { type: "bullet", text: "产品名称：上消化道电子内窥镜手术控制系统；申请人：上海澳华内镜股份有限公司" },
    { type: "bullet", text: "产品名称：3D打印乳房重建组织工程支架；申请人：深圳博瑞捷生物科技有限公司" },
    { type: "bullet", text: "产品名称：显微外科手术控制系统；申请人：昂泰微精医疗科技（上海）有限公司" },
    { type: "bullet", text: "产品名称：胸部CT图像辅助诊断软件；申请人：上海联影智能科技股份有限公司" },
    { type: "bullet", text: "产品名称：颅内深部电极；申请人：北京智冉医疗科技有限公司" },
    { type: "section", text: "02" },
    { type: "heading", text: "多赛道技术集中突破" },
    { type: "paragraph", text: "在本批项目中，人工智能辅助诊断、手术机器人、3D打印植入物及脑机接口等方向均有布局，反映出我国医疗器械创新正从单点突破走向多技术融合发展。" },
    { type: "paragraph", text: "其中，胸部CT图像辅助诊断软件的入选，也再次引发行业对医疗AI发展的关注。" }
  ]
};
